import { render, staticRenderFns } from "./ConsultantDetail.vue?vue&type=template&id=2298a9b1&"
import script from "./ConsultantDetail.vue?vue&type=script&lang=ts&"
export * from "./ConsultantDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports